export default __webpack_public_path__ + "static/media/e09925e8c2c15863bcf3ac4ba71fefd9.3792c417.jpg";